import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BankAccountsPage.MatchBankAccountWithXeroPopup.XeroReconnectWarning', {
    xeroDoesntGrant:
        'Xero does not grant sufficient access to create a bank account. To proceed, please reconnect your company to Xero, and the necessary permissions will be automatically configured.',
    learnMore: 'Learn more',
});
